<template>
  <v-dialog
    v-model="dialog"
    width="328px">
    <div class="dialog-container">
      <h2>Send {{ methodsList[type] }}</h2>

      <div class="dialog-content">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div
            v-show="type === 0"
            class="form-box">
            <span class="label">User</span>
            <el-form-item prop="customer_id">
              <v-select
                v-model="formData.customer_id"
                labelKey="isrd_nm"
                :list="customerOptionsUser"
                remote
                nameGroup
                disabled
                :remoteMethod="remoteMethodUser"
              >
                <template #default="scope">
                  <div class="send-info">
                    <div class="info">
                      {{ scope.item.isrd_nm }}
                    </div>
                  </div>
                </template>
              </v-select>
            </el-form-item>

          </div>
          <div
            v-show="type === 3"
            class="form-box">
            <span class="label">Email</span>
            <el-input
              v-if="inputNo"
              v-model="email"
              placeholder="請輸入郵箱"></el-input>
            <v-select
              v-else
              v-model="emailCustomerId"
              labelKey="email"
              :list="customerOptionsEmail"
              remote
              :remoteMethod="remoteMethodEmail"
              @changeData="changeEmail">
              <template #default="scope">
                <div class="send-info">
                  <div class="info">
                    {{ scope.item.name }} - {{ scope.item.email }}
                  </div>
                  <span>Client</span>
                </div>
              </template>
            </v-select>
          </div>
          <div
            v-show="type === 2 || type === 1"
            class="form-box">
            <span class="label">Phone No.</span>
            <el-input
              v-if="inputNo"
              v-model="phone"
              type="number"
              placeholder="請輸入號碼"></el-input>
            <v-select
              v-else
              v-model="phoneCustomerId"
              labelKey="phone"
              :list="customerOptionsPhone"
              remote
              :remoteMethod="remoteMethod"
              @changeData="changePhone">
              <template #default="scope">
                <div class="send-info">
                  <div class="info">
                    {{ scope.item.name }} - {{ scope.item.phone }}
                  </div>
                </div>
              </template>
            </v-select>
            <!--          <el-select-->
            <!--            v-model="phoneCustomerId"-->
            <!--            filterable-->
            <!--            remote-->
            <!--            reserve-keyword-->
            <!--            placeholder="请输入关键词"-->
            <!--            :remote-method="remoteMethod"-->
            <!--          >-->
            <!--            <el-option-->
            <!--              v-for="item in customerOptionsPhone"-->
            <!--              :key="item.id"-->
            <!--              :label="item.phone"-->
            <!--              :value="item.phone">-->
            <!--            </el-option>-->
            <!--          </el-select>-->
          </div>
          <div class="form-box">
            <span class="label">Content</span>
            <el-form-item prop="content">
              <v-input
                v-model="formData.content"
                type="textarea"
                :rows="4"></v-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="flex-sb-center">
          <div>
            <v-button
              size="small"
              @click="handlerCancel">Cancel
            </v-button>
          </div>
          <div>
            <v-button
              size="small"
              :type="type === 0? 'danger': 'primary'"
              @click="handlerSend">Send
            </v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {sendSMS, sendEmail, sendWhatsApp, sendNotification} from '@/api/ticket'
import {getCustomerOptionsPhone} from '@/api/common'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'NewContactDialog',
  mixins: [MixinOptions,MixinRules],
  props: {
    type: {
      type: Number,
      default: 0
    },
    ticketId: {
      type: [String, Number],
      default: ''
    },
    initCustomerId: {
      type: [Number, String],
      default: ''
    },
    shareLink: {
      type: String,
      default: ''
    },
    isInput: {
      type: Boolean,
      default: false
    },
    customerData:{
      type: Object,
      default: () => ({})
    },
    initPhone: {
      type: String,
      default: ''
    },
    initEmail: {
      type: String,
      default: ''
    },
    initCustomerName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      customerId: '',
      emailCustomerId: '',
      email: '',
      phone: '',
      phoneCustomerId: '',
      content: '',
      methodsList: ['Notification', 'SMS', 'WhatsApp', 'Email'],
      customerPhoneData: [],
      formData:{
        customer_id:'',
        content:''
      }
    }
  },

  computed: {
    ...mapState('common', ['customerOptionsPhone', 'customerOptionsUser', 'customerOptionsEmail']),
    // customerPhoneData() {
    //   this.getCustomerOptionsPhone()
    //   return[]
    //   // return this.customerOptions.filter(item => (item.phone && item.name && String(item.name).trim()))
    // },
    customerEmailData() {
      return this.customerOptions.filter(item => (item.email && item.name && String(item.name).trim()))
    },
    inputNo(){
      return this.isInput
    }
  },
  watch: {
    initCustomerId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.phoneCustomerId = val
          this.emailCustomerId = val
          this.formData.customer_id =val
        }
      }
    },
    initPhone: {
      immediate: true,
      handler(val) {
        this.phone = val
        this.remoteMethod(val, this.type)
      }
    },
    initEmail: {
      immediate: true,
      handler(val) {
        this.email = val
        this.remoteMethodEmail(val, this.type)
      }
    },
    shareLink: {
      immediate: true,
      handler(val) {
        if (val)
        {
          // this.inputNo = true
          this.formData.content = val
        }
      }
    },
    customerData:{
      immediate: true,
      handler(val) {
        if (val)
        {
          let { contact_phone='',contact_email=''} =val
          this.email=contact_email?contact_email:this.email
          this.phone=contact_phone?contact_phone:this.phone
        }
      }
    },
    initCustomerName:{
      immediate: true,
      handler(val) {
        this.remoteMethodUser(val)
      }
    }
  },
  created() {
    this.setCustomerOptionNUll()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone', 'setCustomerOptionNUll', 'getCustomerOptionsEmail', 'getCustomerOptionsUser']),
    changeDialog() {
      this.dialog = !this.dialog
    },
    changeEmail(data) {
      this.email = data.email
    },
    changePhone(data) {
      this.phone = data.phone
    },
    initData() {
      // this.email = ''
      // this.emailCustomerId = ''
      // this.phone = ''
      // this.phoneCustomerId = ''

      this.formData.content = this.shareLink?this.shareLink:''
      // this.customerId = ''
      this.dialog = false
    },
    handlerCancel() {
      this.dialog = false
      this.formData.content = this.shareLink?this.shareLink:''
      // this.setCustomerOptionNUll()
    },
    handlerSend() {
      const type = this.type
      if (type === 1) {
        this.network().sendSMS(this.phone)
      } else if (type === 3) {
        this.network().sendEmail(this.email)
      } else if (type === 0) {
        this.$refs.form.validate((valid, rules) => {
          if(valid){
            this.network().sendNotification()
          }
        })
      }
    },
    handlerResult(data) {
      this.initData()
      // this.setCustomerOptionNUll()
      this.$emit('success')
      this.$message({
        type: 'success',
        message: data.message_language
      })
    },
    remoteMethod(query, type) {
      if (query !== '') {
        this.getCustomerOptionsPhone(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    remoteMethodEmail(query) {
      if (query !== '') {
        this.getCustomerOptionsEmail(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    network() {
      return {
        sendSMS: async () => {
          let params = {}
          if (this.ticketId !== '' && !this.inputNo) {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendSMS({
            content: this.formData.content,
            phone: this.phone,
            customer_id: this.inputNo ? '' : this.phoneCustomerId,
            ...params
          })

          this.handlerResult(data)
        },
        sendEmail: async () => {
          let params = {}
          if (this.ticketId !== '' && !this.inputNo) {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendEmail({
            content: this.formData.content,
            email: this.email,
            customer_id: this.inputNo ? '' : this.emailCustomerId,
            ...params
          })
          this.handlerResult(data)
        },
        sendWhatsApp: async () => {
          let params = {}
          if (this.ticketId !== '') {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendWhatsApp({
            content: this.formData.content,
            phone: this.phone,
            customer_id: this.phoneCustomerId,
            ...params
          })
          this.handlerResult(data)
        },
        sendNotification: async () => {
          let params = {}
          if (this.ticketId !== '') {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendNotification({
            content: this.formData.content,
            customer_id: this.formData.customer_id,
            ...params
          })
          this.handlerResult(data)
          this.$refs.form.clearValidate('content')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-container {
    padding: 15px;
    color: #616266;

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;
    }

    .dialog-content {
      //   padding-top: 15px;
      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
</style>
